import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/courses/course1.jpg'
import _imports_1 from '../../../assets/images/user/user3.jpg'
import _imports_2 from '../../../assets/images/courses/course2.jpg'
import _imports_3 from '../../../assets/images/user/user12.jpg'
import _imports_4 from '../../../assets/images/courses/course3.jpg'
import _imports_5 from '../../../assets/images/user/user13.jpg'
import _imports_6 from '../../../assets/images/courses/course4.jpg'
import _imports_7 from '../../../assets/images/user/user8.jpg'
import _imports_8 from '../../../assets/images/courses/course5.jpg'
import _imports_9 from '../../../assets/images/user/user1.jpg'
import _imports_10 from '../../../assets/images/courses/course6.jpg'
import _imports_11 from '../../../assets/images/user/user5.jpg'
import _imports_12 from '../../../assets/images/courses/course7.jpg'
import _imports_13 from '../../../assets/images/user/user14.jpg'
import _imports_14 from '../../../assets/images/courses/course8.jpg'
import _imports_15 from '../../../assets/images/user/user10.jpg'
import _imports_16 from '../../../assets/images/courses/course9.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-4 col-xxxl-3" }
const _hoisted_3 = { class: "col-lg-8 col-xxxl-9" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_7 = { class: "card-body p-0 letter-spacing" }
const _hoisted_8 = { class: "image position-relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "course-image"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_11 = { class: "content p-20" }
const _hoisted_12 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">4.0</span><span class=\"text-muted fw-medium fs-13\">(21 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 15 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 71 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 37 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$250</span><span class=\"text-muted fs-13 fw-medium ms-5 me-8 text-decoration-line-through\">$350</span><span class=\"text-success fw-medium\"><span class=\"fw-black\">60%</span> Off</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_1 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">J. Ronan</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_18 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_19 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_20 = { class: "card-body p-0 letter-spacing" }
const _hoisted_21 = { class: "image position-relative" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "course-image"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_24 = { class: "content p-20" }
const _hoisted_25 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">5.0</span><span class=\"text-muted fw-medium fs-13\">(32 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 10 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 34 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 21 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$99</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_3 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">J. Pinkman</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_31 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_32 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_33 = { class: "card-body p-0 letter-spacing" }
const _hoisted_34 = { class: "image position-relative" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "course-image"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_37 = { class: "content p-20" }
const _hoisted_38 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-2\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">4.5</span><span class=\"text-muted fw-medium fs-13\">(12 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 20 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 99 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 43 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$140</span><span class=\"text-muted fs-13 fw-medium ms-5 me-8 text-decoration-line-through\">$280</span><span class=\"text-success fw-medium\"><span class=\"fw-black\">50%</span> Off</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_5 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">A. Carter</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_44 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_45 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_46 = { class: "card-body p-0 letter-spacing" }
const _hoisted_47 = { class: "image position-relative" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "course-image"
}, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_50 = { class: "content p-20" }
const _hoisted_51 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">4.0</span><span class=\"text-muted fw-medium fs-13\">(21 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 15 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 71 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 37 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$132</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_7 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">V. Loper</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_57 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_58 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_59 = { class: "card-body p-0 letter-spacing" }
const _hoisted_60 = { class: "image position-relative" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: "course-image"
}, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_63 = { class: "content p-20" }
const _hoisted_64 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_65 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">4.0</span><span class=\"text-muted fw-medium fs-13\">(21 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 15 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 71 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 37 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$45</span><span class=\"text-muted fs-13 fw-medium ms-5 me-8 text-decoration-line-through\">$100</span><span class=\"text-success fw-medium\"><span class=\"fw-black\">45%</span> Off</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_9 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">W. White</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_70 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_71 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_72 = { class: "card-body p-0 letter-spacing" }
const _hoisted_73 = { class: "image position-relative" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: "course-image"
}, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_76 = { class: "content p-20" }
const _hoisted_77 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">4.0</span><span class=\"text-muted fw-medium fs-13\">(21 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 15 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 71 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 37 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$199</span><span class=\"text-muted fs-13 fw-medium ms-5 me-8 text-decoration-line-through\">$300</span><span class=\"text-success fw-medium\"><span class=\"fw-black\">60%</span> Off</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_11 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">T. Skyler</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_83 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_84 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_85 = { class: "card-body p-0 letter-spacing" }
const _hoisted_86 = { class: "image position-relative" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: "course-image"
}, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_89 = { class: "content p-20" }
const _hoisted_90 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_91 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">4.0</span><span class=\"text-muted fw-medium fs-13\">(21 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 15 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 71 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 37 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$45</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_13 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">K. Hong</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_96 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_97 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_98 = { class: "card-body p-0 letter-spacing" }
const _hoisted_99 = { class: "image position-relative" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  alt: "course-image"
}, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_102 = { class: "content p-20" }
const _hoisted_103 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_104 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">4.0</span><span class=\"text-muted fw-medium fs-13\">(21 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 15 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 71 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 37 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$54</span><span class=\"text-muted fs-13 fw-medium ms-5 me-8 text-decoration-line-through\">$100</span><span class=\"text-success fw-medium\"><span class=\"fw-black\">54%</span> Off</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_15 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">B. Traversy</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_109 = { class: "col-sm-6 col-lg-6 col-xxxl-4" }
const _hoisted_110 = { class: "card mb-25 border-0 rounded-0 bg-white single-course-card" }
const _hoisted_111 = { class: "card-body p-0 letter-spacing" }
const _hoisted_112 = { class: "image position-relative" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  alt: "course-image"
}, null, -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("button", {
  class: "fav position-absolute bg-white rounded-circle border-0 p-0 d-inline-block",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart" })
], -1)
const _hoisted_115 = { class: "content p-20" }
const _hoisted_116 = { class: "mb-10 fw-semibold fs-16 fs-lg-18" }
const _hoisted_117 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center\"><div class=\"rating lh-1\"><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star-1\"></i><i class=\"flaticon-star\"></i></div><span class=\"text-black fw-bold fs-13 ms-5 me-5\">4.0</span><span class=\"text-muted fw-medium fs-13\">(21 Reviews)</span></div><ul class=\"mb-0 ps-0 list-unstyled info\"><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-book\"></i> 15 <span class=\"text-muted\">Classes</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-user-3\"></i> 71 <span class=\"text-muted\">Enrolled</span></li><li class=\"d-inline-block text-black position-relative\"><i class=\"flaticon-clock\"></i> 37 <span class=\"text-muted\">Hrs</span></li></ul><div class=\"mt-12 price d-flex align-items-end\"><span class=\"text-primary lh-1 fw-bold fs-16 fs-md-20 fs-lg-25\">$29</span></div><div class=\"mt-15 d-flex align-items-center\"><img src=\"" + _imports_1 + "\" width=\"24\" height=\"24\" class=\"rounded-circle\" alt=\"user\"><span class=\"d-block text-black ms-8 fs-md-15 fs-lg-16 fw-medium\">J. Ronan</span></div><button type=\"button\" class=\"add-to-cart-btn text-center d-block mt-15 fw-medium transition w-100 rounded-1 position-relative\"> Add To Cart <i class=\"flaticon-shopping-cart-2 transition\"></i></button>", 5)
const _hoisted_122 = /*#__PURE__*/_createStaticVNode("<div class=\"pagination-area d-md-flex mb-25 justify-content-between align-items-center\"><p class=\"mb-0 text-paragraph\"> Showing <span class=\"fw-bold\">09</span> out of <span class=\"fw-bold\">134</span> results </p><nav class=\"mt-15 mt-md-0\"><ul class=\"pagination mb-0\"><li class=\"page-item\"><a class=\"page-link\" href=\"#\" aria-label=\"Previous\"><i class=\"flaticon-chevron-1\"></i></a></li><li class=\"page-item\"><a class=\"page-link active\" href=\"#\">1</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">2</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\">3</a></li><li class=\"page-item\"><a class=\"page-link\" href=\"#\" aria-label=\"Next\"><i class=\"flaticon-chevron\"></i></a></li></ul></nav></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SideBar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h4", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Artificial Intelligence A-Z 2024: Build an AI with ChatGPT4 ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_13
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }),
                _hoisted_23
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h4", _hoisted_25, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" TensorFlow Developer Certificate in 2024: Zero to Mastery ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_26
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }),
                _hoisted_36
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h4", _hoisted_38, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Complete Machine Learning & Data Science Bootcamp 2024 ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_39
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 1
                }),
                _hoisted_49
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("h4", _hoisted_51, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Photoshop Master Course: From Beginner to Photoshop Pro ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_52
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_61
                  ]),
                  _: 1
                }),
                _hoisted_62
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("h4", _hoisted_64, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" User Experience (UX): The Ultimate Guide to Usability and UX ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_65
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_74
                  ]),
                  _: 1
                }),
                _hoisted_75
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("h4", _hoisted_77, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Adobe Audition CC Tutorial - Audition Made Easy ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_78
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_87
                  ]),
                  _: 1
                }),
                _hoisted_88
              ]),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("h4", _hoisted_90, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Web Development Masterclass & Certifications ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_91
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_100
                  ]),
                  _: 1
                }),
                _hoisted_101
              ]),
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("h4", _hoisted_103, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create a Complete 2D Survivors Style Game in Godot 4 ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_104
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_109, [
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _createVNode(_component_router_link, {
                  to: "/course-details",
                  class: "d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_113
                  ]),
                  _: 1
                }),
                _hoisted_114
              ]),
              _createElementVNode("div", _hoisted_115, [
                _createElementVNode("h4", _hoisted_116, [
                  _createVNode(_component_router_link, {
                    to: "/course-details",
                    class: "text-decoration-none text-black"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" The Complete Python Bootcamp From Zero to Hero in Python ")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_117
              ])
            ])
          ])
        ])
      ]),
      _hoisted_122
    ])
  ]))
}